import { IContext } from 'msteams-ui-components-react'
import { createThemeObject } from 'utils'

const getThemeStyles = (context: IContext) => {
	const { light, dark, highContrast: contrast } = context.colors
	return createThemeObject(context, {
		wrapper: {
			light: {
				color: light.black
			},
			dark: {
				color: dark.white
			},
			contrast: {
				color: contrast.white
			}
		}
	})
}

export default getThemeStyles
